"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _HBModalBase = _interopRequireDefault(require("../HBModalBase/HBModalBase"));
var _HBModalCloseButton = _interopRequireDefault(require("../HBModalBase/HBModalCloseButton"));
var _PaginationDots = _interopRequireDefault(require("../common/PaginationDots"));
var _PreloadMediaElements = _interopRequireDefault(require("../common/PreloadMediaElements"));
var _CalloutMediaElement = _interopRequireDefault(require("../common/Callout/CalloutMediaElement"));
var _utils = require("../HBBanner/utils");
var _useWindowSize2 = require("../common/useWindowSize");
var _breakpoints = require("../../styles/breakpoints");
var _HBModalActions = _interopRequireDefault(require("../HBModalBase/HBModalActions"));
var _HBDrawer = _interopRequireDefault(require("../HBDrawer/HBDrawer"));
var _excluded = ["maxWidth", "withImagePadding", "imageWidth", "imageFit", "size", "layout", "testId", "testIdName", "closeButtonTheme", "id", "isOpen", "onClose", "belowCTAText", "autoPlay", "muted", "controls"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var HBCalloutModal = function HBCalloutModal(_ref, ref) {
  var maxWidth = _ref.maxWidth,
    withImagePadding = _ref.withImagePadding,
    imageWidth = _ref.imageWidth,
    imageFit = _ref.imageFit,
    _ref$size = _ref.size,
    _size = _ref$size === void 0 ? 'md' : _ref$size,
    _layout = _ref.layout,
    testId = _ref.testId,
    testIdName = _ref.testIdName,
    closeButtonTheme = _ref.closeButtonTheme,
    id = _ref.id,
    isOpen = _ref.isOpen,
    _onClose = _ref.onClose,
    belowCTAText = _ref.belowCTAText,
    autoPlay = _ref.autoPlay,
    muted = _ref.muted,
    controls = _ref.controls,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    currStepIndex = _useState2[0],
    setCurrStepIndex = _useState2[1];
  var _useWindowSize = (0, _useWindowSize2.useWindowSize)(),
    isMediumUp = _useWindowSize.isMediumUp;
  var layout = isMediumUp ? _layout : 'default';
  var size = isMediumUp ? _size : 'md';
  var isSideBySide = layout === 'side-by-side';
  var isPaginated = 'steps' in props;
  var align = isSideBySide ? 'start' : layout === 'center' ? 'center' : 'end';
  var _SIZES$size = SIZES[size],
    titleType = _SIZES$size.titleType,
    descriptionType = _SIZES$size.descriptionType;
  var title;
  var description;
  var mediaPath;
  var primaryAction;
  var secondaryAction;
  if (isPaginated) {
    var step = props.steps[currStepIndex];
    title = step.title;
    description = step.description;
    mediaPath = step.mediaPath;
    primaryAction = {
      text: step.primaryActionText,
      onClick: function onClick() {
        var _step$primaryActionOn;
        (_step$primaryActionOn = step.primaryActionOnClick) === null || _step$primaryActionOn === void 0 || _step$primaryActionOn.call(step);
        if (currStepIndex < props.steps.length - 1) {
          setCurrStepIndex(function (prev) {
            return prev + 1;
          });
        } else {
          _onClose();
          setCurrStepIndex(0);
        }
      }
    };
    secondaryAction = 'secondaryActionText' in step && {
      text: step.secondaryActionText,
      onClick: function onClick() {
        return setCurrStepIndex(function (prev) {
          return prev - 1;
        });
      }
    };
  } else {
    title = props.title;
    description = props.description;
    mediaPath = props.mediaPath;
    primaryAction = props.primaryAction;
    secondaryAction = props.secondaryAction;
  }
  var paginationContent = isPaginated && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_PaginationDots["default"], {
    activeIndex: currStepIndex,
    count: props.steps.length
  }), isOpen && /*#__PURE__*/_react["default"].createElement(_PreloadMediaElements["default"], {
    mediaPaths: props.steps.map(function (step) {
      return (0, _utils.isLottieAnimation)(step.mediaPath) ? undefined : step.mediaPath;
    })
  }));
  var mediaContent = /*#__PURE__*/_react["default"].createElement(_CalloutMediaElement["default"], {
    mediaPath: mediaPath,
    imageFit: imageFit,
    withImagePadding: isMediumUp && withImagePadding,
    layout: layout,
    width: imageWidth,
    autoPlay: autoPlay,
    muted: muted,
    controls: controls
  });
  var children = /*#__PURE__*/_react["default"].createElement(Container, {
    $layout: layout,
    $maxWidth: isMediumUp && maxWidth
  }, !isSideBySide && mediaContent, /*#__PURE__*/_react["default"].createElement(Content, null, /*#__PURE__*/_react["default"].createElement(TextContainer, {
    $layout: layout,
    $size: size
  }, typeof title === 'string' ? /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: titleType
  }, title) : title, typeof description === 'string' ? /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: descriptionType
  }, description) : description), /*#__PURE__*/_react["default"].createElement(FooterWrapper, {
    $layout: layout
  },
  // Avoid of rendering an empty footer, it causes a gap between the content and the belowCTAText
  (paginationContent || isMediumUp) && /*#__PURE__*/_react["default"].createElement(Footer, {
    $layout: layout
  }, !isSideBySide && paginationContent, isMediumUp && /*#__PURE__*/_react["default"].createElement(_HBModalActions["default"], {
    primaryAction: primaryAction,
    secondaryAction: secondaryAction,
    align: align
  }), isSideBySide && paginationContent), belowCTAText && /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: "body12",
    color: "textTertiary"
  }, belowCTAText))), isSideBySide && mediaContent);
  if (!isMediumUp) {
    var primaryActionWithTestIds = primaryAction && _objectSpread(_objectSpread({}, primaryAction), (0, _utils.getTestIdProps)({
      testId: testId,
      testIdName: testIdName,
      suffix: 'primary'
    }));
    var secondaryActionWithTestIds = secondaryAction && _objectSpread(_objectSpread({}, secondaryAction), (0, _utils.getTestIdProps)({
      testId: testId,
      testIdName: testIdName,
      suffix: 'secondary'
    }));
    return /*#__PURE__*/_react["default"].createElement(_HBDrawer["default"], {
      open: isOpen,
      onClose: function onClose() {
        return _onClose();
      },
      primaryAction: primaryActionWithTestIds,
      secondaryAction: secondaryActionWithTestIds,
      removeTopPadding: true
    }, children);
  }
  return /*#__PURE__*/_react["default"].createElement(_HBModalBase["default"], {
    id: id,
    ref: ref,
    isOpen: isOpen,
    testId: testId,
    testIdName: testIdName,
    onClose: _onClose
  }, children, /*#__PURE__*/_react["default"].createElement(_HBModalCloseButton["default"], {
    theme: closeButtonTheme
  }));
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.forwardRef)(HBCalloutModal); // -------------------------- Styles -------------------------- //
var SIZES = {
  sm: {
    titleType: 'title20',
    descriptionType: 'body14',
    textContainerGap: '12px'
  },
  md: {
    titleType: 'display24',
    descriptionType: 'body16',
    textContainerGap: '16px'
  },
  lg: {
    titleType: 'display32',
    descriptionType: 'body18',
    textContainerGap: '20px'
  }
};
var Container = _styledComponents["default"].div.withConfig({
  displayName: "HBCalloutModal__Container",
  componentId: "sc-1kwaff4-0"
})(function (_ref2) {
  var $layout = _ref2.$layout,
    $maxWidth = _ref2.$maxWidth;
  return (0, _styledComponents.css)(["display:flex;max-width:", "px;overflow:hidden;border-radius:inherit;position:relative;", ""], $maxWidth, $layout !== 'side-by-side' && (0, _styledComponents.css)(["flex-direction:column;"]));
});
var Content = _styledComponents["default"].div.withConfig({
  displayName: "HBCalloutModal__Content",
  componentId: "sc-1kwaff4-1"
})(["padding:32px 0 0;", "{padding:32px;}gap:32px;display:flex;flex-direction:column;justify-content:space-between;flex-shrink:1000000;"], _breakpoints.mediumUp);
var TextContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBCalloutModal__TextContainer",
  componentId: "sc-1kwaff4-2"
})(["display:flex;flex-direction:column;gap:", ";", " white-space:pre-line;"], function (_ref3) {
  var $size = _ref3.$size;
  return SIZES[$size].textContainerGap;
}, function (_ref4) {
  var $layout = _ref4.$layout;
  return $layout === 'center' && (0, _styledComponents.css)(["text-align:center;"]);
});
var Footer = _styledComponents["default"].div.withConfig({
  displayName: "HBCalloutModal__Footer",
  componentId: "sc-1kwaff4-3"
})(["display:flex;gap:24px;", ";"], function (_ref5) {
  var $layout = _ref5.$layout;
  return $layout === 'center' ? (0, _styledComponents.css)(["flex-direction:column;align-items:center;"]) : (0, _styledComponents.css)([""]);
});
var FooterWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBCalloutModal__FooterWrapper",
  componentId: "sc-1kwaff4-4"
})(["display:flex;flex-direction:column;gap:16px;", ";"], function (_ref6) {
  var $layout = _ref6.$layout;
  return $layout === 'center' && (0, _styledComponents.css)(["align-items:center;"]);
});
//# sourceMappingURL=HBCalloutModal.js.map